import * as React from "react";
import * as ReactDOM from "react-dom";
import * as styles from "./styles.scss";
import { Html } from "../../../../components";

interface IProps {
  value: any;
}

const renderItem = (props: any, i: any) => {
  const attributes: any = { className: styles.item, key: i };

  if (typeof props.option === "string") {
    return (
      <div {...attributes}>
        <Html>{props.option}</Html>
      </div>
    );
  }

  attributes.style = { backgroundImage: `url(${props.option.src})` };
  attributes.className += ` ${styles.image}`;

  return <div {...attributes} />;
};

export const Sort = ({ value }: IProps) => (
  <div className={styles.sort}>{value.map(renderItem)}</div>
);
